import { getPlainDateOrNullFrom } from './temporalUtils';
/**
 * Returns the long date format (e.g. January 1, 2000) of
 * the ISO date string in the given locale. If locale is not
 * specified, it will use the locale set in the document's
 * lang attribute, or the browser's default language.
 */
export function formatLongIsoDateString(
  date: string,
  locale: string = document.documentElement.lang
): string {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot format an invalid date, ${date}`);
  }
  // Empty locale string is converted to undefined and falls back to browser locale.
  return plainDate.toLocaleString(locale || undefined, {
    dateStyle: 'long',
  });
}
/**
 * Returns the short date format ("1/2/06") of
 * the ISO date string in the given locale. If locale is not
 * specified, it will use the locale set in the document's
 * lang attribute, or the browser's default language.
 */
export function formatShortIsoDateString(
  date: string,
  locale: string = document.documentElement.lang
): string {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot format an invalid date, ${date}`);
  }
  return plainDate.toLocaleString(locale || undefined, {
    dateStyle: 'short',
  });
}

/**
 * Returns a custom date format for use in tables
 * ("Wed 22") of the ISO date string in the given locale. If locale is not
 * specified, it will use the locale set in the document's
 * lang attribute, or the browser's default language.
 */
export function formatIsoDateStringForTable(
  date: string,
  locale: string = document.documentElement.lang
): string {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot format an invalid date, ${date}`);
  }
  const shortWeekdayString = plainDate.toLocaleString(locale || undefined, {
    weekday: 'short',
  });

  const numericDay = plainDate.toLocaleString(locale || undefined, {
    day: 'numeric',
  });

  // Empty locale string is converted to undefined and falls back to browser locale.
  return `${shortWeekdayString} ${numericDay}`;
}
